export const DEFAULT_FILTER_SLUG = "newestMovies";
